import script from "./NewsPageFullView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageFullView.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageFullView.vue?vue&type=style&index=0&id=58b62ffe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b62ffe"]])

export default __exports__